import apiService from './api';

const READER_URL = '/readers';

// Create a new reader
export const createReader = async (readerData) => {
  try {
    const response = await apiService.post(READER_URL, readerData);
    return response;
  } catch (error) {
    console.error('Failed to create reader:', error);
    throw error;
  }
};

// Get all readers for the current user
export const getUserReaders = async () => {
  try {
    const response = await apiService.get(READER_URL);
    return response;
  } catch (error) {
    console.error('Failed to get readers:', error);
    throw error;
  }
};

// Get a reader by ID
export const getReaderById = async (readerId) => {
  try {
    const response = await apiService.get(`${READER_URL}/${readerId}`);
    return response;
  } catch (error) {
    console.error('Failed to get reader:', error);
    throw error;
  }
};

// Update a reader
export const updateReader = async (readerId, readerData) => {
  try {
    const response = await apiService.put(`${READER_URL}/${readerId}`, readerData);
    return response;
  } catch (error) {
    console.error('Failed to update reader:', error);
    throw error;
  }
};

// Delete a reader
export const deleteReader = async (readerId) => {
  try {
    const response = await apiService.delete(`${READER_URL}/${readerId}`);
    return response;
  } catch (error) {
    console.error('Failed to delete reader:', error);
    throw error;
  }
};

// Get all chapters read by a reader
export const getReaderReadingHistory = async (readerId) => {
  try {
    const response = await apiService.get(`${READER_URL}/${readerId}/reading`);
    return response;
  } catch (error) {
    console.error('Failed to get reading history:', error);
    throw error;
  }
};

// Get reading statistics for a reader
export const getReaderStats = async (readerId) => {
  try {
    const response = await apiService.get(`${READER_URL}/${readerId}/stats`);
    return response;
  } catch (error) {
    console.error('Failed to get reader stats:', error);
    throw error;
  }
};

// Check if a chapter has been read by a reader
export const checkChapterRead = async (readerId, chapterId) => {
  try {
    const response = await apiService.get(`${READER_URL}/${readerId}/chapters/${chapterId}`);
    return response;
  } catch (error) {
    console.error('Failed to check chapter read status:', error);
    throw error;
  }
}; 